var currentUrl = document.URL;
var urlParts   = currentUrl.split('#');
var anchor = (urlParts.length > 1) ? urlParts[1] : '';

if($('#accordion-financing').length > 0) {
  $('#btn-'+anchor).click();
}
